module.exports = __webpack_public_path__ + "static/media/wiz_kayak_active_ic.8f9d97e9.svg";